/**
 * Public page theme packs. Add a pack here, drop its CSS under themes/<id>/,
 * import the CSS from themes/load.ts, and add the same id to CatalogTheme on
 * the API — then it appears in the catalog settings dropdown.
 */
import type { CatalogTheme } from "../../api/types";

export interface PublicThemeOption {
  id: CatalogTheme;
  /** Key under `t.catalog.theme`. */
  labelKey: CatalogTheme;
}

export const PUBLIC_THEMES: readonly PublicThemeOption[] = [
  { id: "default", labelKey: "default" },
  { id: "tina", labelKey: "tina" },
] as const;

export function isCatalogTheme(value: string): value is CatalogTheme {
  return PUBLIC_THEMES.some((theme) => theme.id === value);
}
